import { ActivityParticipantData } from '.';
import { AgendaItem } from '.';
import { ActivityOwner } from '.';

export const ActiveActivityTypes:ActivityType[] = [
    'WorkgroupMeeting',
    'SafetyInspection',
    'WorkplaceAssessment',
    'AnnualWorkgroupStatus'
];

export type ActivityType = typeof ActivityTypes[number];
export const ActivityTypes = [
    'AnnualWorkgroupStatus',
    'WorkgroupMeeting',
    'WorkplaceAssessment',
    'Presentation',
    'Lecture',
    'Training',
    'SafetyInspection',
    'Treatment',
    'CustomForm',
    'IndependentActionPlan',
    'ArticleActionPlan'
] as const;

export const MeetingActivityTypes:ActivityType[] = [
    'AnnualWorkgroupStatus',
    'WorkgroupMeeting',
];

export const NonMeetingActivityTypes:ActivityType[] = [
    'Presentation',
    'Lecture',
    'Training',
    'SafetyInspection',
    'Treatment'
]

export type ActivityInvitationType =
    'ShowUp' |
    'SignUp' |
    'InviteOnly';

export class Activity
{
    constructor(
        public id:string,
        public activityType:ActivityType,
        public invitationType:ActivityInvitationType,
        public title:string,
        public description:string,
        public start:Date,
        public end:Date,
        public location:string,
        public workgroupId:string,
        public workgroupName:string,
        public owner:ActivityOwner | null,

        // unique to Activity (vs ActivityListing)
        public participants:ActivityParticipantData[],
        public agendaItems:AgendaItem[]
    ){}
}

export type MeetingInvitationSnapshot = {
    activityId:string,
    title:string,
    description:string,
    start:Date,
    end:Date,
    location:string,
    agendaItems:string[],
    participants:MeetingInvitationParticipant[]
}

export type MeetingInvitationParticipant = {
    id:string,
    email:string,
    name:string
}

export type MeetingInvitationRecord = {
    id:string,
    activityId:string,
    sentBy:{userId:string, name:string, email:string},
    sent:Date,
    snapshot:MeetingInvitationSnapshot,
}

export type MeetingParticipantUpdate = {
    id:string,
    email:string,
    action:'added'|'update'|'removed'
};

export type MeetingInvitationStatus = {
    status:'not-sent' | 'up-to-date' | 'has-changes'
}